import { post, get, deletee, put, convertToForm } from '.';
import { AxiosPromise } from 'axios';

import { getAuth } from './localStorage';

export const getAllStaticAsset = (
  params: IGetAssetParams
): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return get({
    subUrl: '/static-assets/',
    params: { ...params }
  });
};

export const addAsset = (data: IAssetParam): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return post({
    subUrl: '/static-assets',
    data: convertToForm(data),
    headers: { "Content-Type": undefined }
  });
};

export const updateAsset = (data: IAssetParam): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return put({
    subUrl: '/static-assets',
    data: convertToForm(data),
    headers: { "Content-Type": undefined }
  });
};

export const deleteAsset = (data: IAssetDeleteParam): AxiosPromise<any> => {
  console.log(data);
  return deletee({
    subUrl: '/static-assets',
    params: { ...data }
  });
};

export const orderAsset = (data: {
  id: string;
  index: number;
  assetType: string;
}) => {
  return post({
    subUrl: '/static-assets/adjust-order',
    data
  });
};

export type getPartData = {
  id: string;
};

export type IAssetParam = {
  id?: string;
  assetType: 'VIDEO' | 'SHORTCUT_KEYS';
  en_title: string;
  en_summary: string;
  zh_title?: string;
  zh_summary?: string;
  src?: string;
  thumb?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type IGetAssetParams = {
  offset?: number;
  assetType: 'VIDEO' | 'SHORTCUT_KEYS';
  search?: string;
  limit?: number;
};

type IAssetDeleteParam = {
  id: string;
  assetType: 'VIDEO' | 'SHORTCUT_KEYS';
};
